<table class="table">
    <thead>
        <tr>
            <th>Sequence No</th>
            <th>Employee</th>
        </tr>
    </thead>

    <tbody>
        <tr *ngFor="let item of ValidationLevel; let i = index;">
            <td>{{item.SrNo}}</td>
            <td>
                <ng-select bindLabel="name" placeholder="Select Employee" [multiple]="false" name="sctEmployee"
                    class="ngSelect250" (ngModelChange)="EmployeeModelChange()" [searchable]="true" (keyup)="onEmployeeCodeKeypress($event)"
                    [(ngModel)]="item.EmployeeId">
                    <ng-option [value]="e.employeeId" *ngFor="let e of EmployeeCodes">
                        {{e.employeeCode}} - {{e.employeeName}}
                    </ng-option>
                </ng-select>                
            </td>
        </tr>

</table>